import React from 'react';
import { DataContext } from '../App';
import arrowUp from '../Assets/arrowUp.svg';
import arrowDown from '../Assets/arrowDown.svg';
import arrowRight from '../Assets/minus.svg';

function PestPressure() {
    const data = React.useContext(DataContext);

    const pestPressure = data.predicted_relative_fruit_fly_pressure;

    let arrow = pestPressure > 0 ? "Arrow Up Circle" : "Arrow Down Circle";
    let arrowSVG = pestPressure > 0 ? arrowUp : arrowDown;
    let trend = pestPressure > 0 ? "Increase" : "Decrease";

    
    if (pestPressure == 0){
        arrow = "Arrow Right Circle";
        arrowSVG = arrowRight;
        trend = "Change"
    }


    return (
        <div className="card-body d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center">
                    <img className="fs-big-img" src={arrowSVG} alt={arrow} />
                <div className="ml-3">
                    <h1 className="text-black font-weight-bold text-center mb-0">
                        {Math.abs(pestPressure)}%
                    </h1>
                    <h5 className="text-black mb-0">
                        {trend}
                    </h5>
                </div>
            </div>
        </div>
    );
}

export default PestPressure;